import { Info } from 'lucide-react'
import { ReferralInvitePrompt } from 'modules/referrals/ReferralInvitePrompt'
import { CREDITS_ADD_CTA, CREDITS_EXHAUSTED_SUBTITLE, CREDITS_EXHAUSTED_TITLE } from '../constants'

type CreditsExhaustedNoticeProps = {
  variant: 'banner' | 'card' | 'card-detail'
  onTopUp: () => void
  detail?: string
}

function AddCreditsCta({ className, onTopUp }: { className: string; onTopUp: () => void }) {
  return (
    <button type="button" onClick={onTopUp} className={className}>
      {CREDITS_ADD_CTA}
    </button>
  )
}

export function CreditsExhaustedNotice({ variant, onTopUp, detail }: CreditsExhaustedNoticeProps) {
  if (variant === 'banner') {
    return (
      <div className="system-banner" role="status">
        <div className="mx-auto flex max-w-[1400px] flex-col items-stretch justify-between gap-3 px-5 py-3 sm:flex-row sm:items-center sm:gap-4 sm:px-6">
          <p className="flex flex-wrap items-center gap-2 text-[13px]">
            <Info size={16} className="shrink-0 text-paper-dim" aria-hidden />
            <span className="font-semibold text-paper">{CREDITS_EXHAUSTED_TITLE}</span>
            <span className="text-paper-dim">{CREDITS_EXHAUSTED_SUBTITLE}</span>
          </p>
          <AddCreditsCta className="btn-acid-outline w-full sm:w-auto" onTopUp={onTopUp} />
        </div>
      </div>
    )
  }

  if (variant === 'card-detail') {
    return (
      <div className="system-card flex items-start gap-3 p-4" role="status">
        <Info size={20} className="mt-0.5 flex-shrink-0 text-paper-dim" aria-hidden />
        <div className="flex-1">
          <p className="text-[14px] font-semibold text-paper">{CREDITS_EXHAUSTED_TITLE}</p>
          <p className="mt-0.5 text-[12px] text-paper-dim">{CREDITS_EXHAUSTED_SUBTITLE}</p>
          {detail ? <p className="mt-1 text-[12px] text-paper-dim">{detail}</p> : null}
          <AddCreditsCta className="link-acid mt-2" onTopUp={onTopUp} />
          {/* Alternate to paying — invite a friend for credits. Self-hides when
              the referral program is disabled for this user. */}
          <ReferralInvitePrompt surface="credits_exhausted" className="mt-3" />
        </div>
      </div>
    )
  }

  return (
    <div className="system-card flex items-center gap-3 p-3" role="status">
      <Info size={16} className="flex-none text-paper-dim" aria-hidden />
      <div className="min-w-0 flex-1">
        <p className="text-[13px] font-semibold text-paper">{CREDITS_EXHAUSTED_TITLE}</p>
        <p className="text-[12px] text-paper-dim">{CREDITS_EXHAUSTED_SUBTITLE}</p>
      </div>
      <AddCreditsCta className="link-acid shrink-0" onTopUp={onTopUp} />
    </div>
  )
}
